module.exports = __webpack_public_path__ + "static/media/01anjianyuan2.c994c50c.png";